/** Variable sets per trigger type */
export const TRIGGER_VARS: Record<string, string[]> = {
  'failed-payment': [
    '{item}',
    '{name}',
    '{first_name}',
    '{last_name}',
    '{last4}',
    '{failure_message}',
  ],
  anniversary: ['{name}', '{years}'],
  'low-stock-threshold': [
    '{quantity_before}',
    '{quantity_after}',
    '{adjusted_by}',
    '{note}',
    '{reason}',
  ],
};

/** Generic placeholder variables for most trigger types */
export const GENERIC_VARS = [
  '{item}',
  '{name}',
  '{first_name}',
  '{last_name}',
  '{service}',
  '{date}',
  '{time}',
];

export const GENERIC_VAR_TYPES = new Set<string>([
  'subscription-renewal',
  'client-signup',
  'birthdate',
  'trial-end',
  'package-expired',
  'assessment-completed',
  'visit-booked',
  'visit-completed',
  'visit-closed',
  'visit-no-showed',
  'visit-late-canceled',
  'subscription-downgrade',
  'workout-plan-completed',
  'workout-completed',
  'all',
  'some',
  'opened-app',
  'add-tag',
  'remove-tag',
]);

export const getVarsForTrigger = (type: string): string[] => {
  if (TRIGGER_VARS[type]) return TRIGGER_VARS[type];
  if (GENERIC_VAR_TYPES.has(type)) return GENERIC_VARS;
  return [];
};

export type VariableToken = {
  start: number;
  end: number;
  raw: string;
  isValid: boolean;
};

const TOKEN_RE = /\{([a-z0-9_]+)\}/gi;

export const normalizeVariableText = (value: unknown): string =>
  typeof value === 'string' ? value : '';

export const getAutomationMessageContent = (content: unknown): string => {
  const messageContent = Array.isArray(content) ? content[0] : content;
  return normalizeVariableText(messageContent);
};

export const parseVariableTokens = (
  text: string,
  validVars: string[]
): VariableToken[] => {
  const valid = new Set(validVars.map((v) => v.toLowerCase()));
  const out: VariableToken[] = [];

  for (const match of text.matchAll(TOKEN_RE)) {
    out.push({
      start: match.index ?? 0,
      end: (match.index ?? 0) + match[0].length,
      raw: match[0],
      isValid: valid.has(match[0].toLowerCase()),
    });
  }

  return out;
};

export const getUnknownVariables = (
  text: string,
  validVars: string[]
): string[] => {
  if (validVars.length === 0) return [];

  return [
    ...new Set(
      parseVariableTokens(text, validVars)
        .filter((token) => !token.isValid)
        .map((token) => token.raw)
    ),
  ];
};
